import {useMemo} from 'react';
import {assert} from 'assert-ts';
import {selectSettingsPreferredLocale} from 'services/settings';
import {useAppSelector} from 'store/hooks';
import type {Thesaurus, ThesaurusId} from '../types';
import {selectThesaurusData} from '../thesaurusSelectors';
import {getDummyThesaurus} from './getDummyThesaurus';

export const useThesaurus = (id: ThesaurusId): Thesaurus => {
  const language = useAppSelector(selectSettingsPreferredLocale);
  const thesaurus = useAppSelector(selectThesaurusData(id, language));

  return useMemo(() => {
    if (
      assert.soft(thesaurus, `useThesaurus: Thesaurus "${id}" not loaded`, {
        id,
      })
    ) {
      return thesaurus;
    }
    return getDummyThesaurus(id);
  }, [thesaurus, id]);
};
